// CategorySelect.jsx
import React from 'react';

export default function CategorySelect({ value, onChange, errorText, required, disabled = false }) {
  return (
    <div className="form-input-expense" style={{ marginTop: 20 }}>
      <label className="form-input-label-expense">Category*</label>
      <select
        name="category"
        className="form-input-field-expense"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        disabled={disabled}
      >
        <option value="">Select category</option>
        <option value="Travel">Travel</option>
        <option value="Other Direct Costs">Non-billable Expenses</option>
        {/* <option value="Sub-Contracting">Sub-Contracting</option> */}
        <option value="Reimbursable Expenses">Billable Expenses</option>
      </select>
      {errorText ? <div className="error-text">{errorText}</div> : null}
    </div>
  );
}
